import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { admin } = useAuth();

  if (admin === null) {
    return (
      <div
        data-testid="protected-route-loading"
        className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-500 text-sm"
      >
        Checking session…
      </div>
    );
  }

  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }

  return children;
}
